<template>
  <div class="areas-index" :style="{ width: lineWidth + 'px' }">
    <div class="areas-index__line" />
    <div class="areas-index__description">
      <div class="areas-index__description__icon">
        <img
          :src="`${$baseUrl}images/icons-chart/${content.id}-area-road2050.svg`"
        />
      </div>
      <div class="areas-index__description__label" v-html="content.title" />
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      lineWidth: 0,
    };
  },
  props: {
    content: {
      type: Object,
      required: true,
    },
    isLastOne: Boolean,
  },
  mounted() {
    this.$nextTick(() => {
      this.lineWidth = document
        .querySelector("#" + this.content.id)
        .getBoundingClientRect().width;
    });
  },
};
</script>

<style lang="scss" scoped>
.areas-index {
  padding-right: 0.9rem;

  &__description {
    display: flex;
    align-items: center;
    margin-top: toRem(10);

    &__icon {
      padding-right: 0.5rem;

      img {
        height: 1.5rem;
      }
    }
    &__label {
      @include title-xs;

      font-size: 1.1rem;
      text-transform: uppercase;
      color: var(--scala-grigi-gray-5);
      padding-right: 0.9rem;
      white-space: nowrap;
    }
  }

  &__line {
    width: 100%;
    border-bottom: 1px solid var(--white-100);
  }
}
</style>
